module.exports = __webpack_public_path__ + "static/eti1-d2fa5b6cba68000253ce9ed95ce7f4d8.png";